import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

/* import useTableScroll from "../components/useTableScroll.js";
 */ 
import { Mensaje } from '../mensajes2';
import { Dimmer } from '../spinner';
import axios from "axios";
import moment from 'moment';
import { formatMoneda, validaSoloNumero } from '../../util/varios';



const AgregarProducto = props => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const txtId = useRef();
    const txtFecha = useRef();
    const txtObservacion = useRef();
    const txtConcepto = useRef();
    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [valor, setValor] = useState(0.00);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [mostrar, setMostrar] = useState(false);
    const [operacion, setOperacion] = useState(0)
    const headCells = [
        { label: 'CODIGO', textAlign: 'center' },
        { label: 'CONCEPTO', textAlign: 'center' },
        { label: 'FECHA SOLICITUD', textAlign: 'center' },
    ]

    /*    const {
           TblContainer,
           TblHead,
           TblPagination,
           recordsAfterPagingAndSorting
       } = useTableScroll(records, headCells, filterFn);
    */
    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.razon.includes(target.value)
                            || x.rif.includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarRegistros = () => {

        setActivate(true);


        let endpoint = `${op.conexion}/api/comprasAlmacen/catalogorequisicion?efi=${idefiscal}`

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                setActivate(false);
                /*  var datos = []
                 for (let i = 0; i < response.data.length; i++) {
                     datos.push({
                         id: response.data[i].idproveedor,
                         razon: response.data[i].razonsocial,
                         dencomer: response.data[i].denominacioncomercial,
                         direccion: response.data[i].direccion,
                         rif: response.data[i].rif,
                         tipo: response.data[i].tipo,
                     })
                 }     */
                console.log(response.data)
                setRecords(response.data)
            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const seleccionarClassPresupuestaria = () => {
        blanquear();
        console.log(values.id)
        props.onHideAceptaOrganismo(values.id);
        props.onHideCancelar();
    };

    const seleccionarRegistroTipReten = (id) => {
        setMostrar(false)

      
        let campos = '*';
        let nomtab = 'producto';
        let nomid = 'idproducto';

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

        console.log(endpoint);

        setActivate(true);
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {
            if (response.status === 200) {



                if (response.data !== '') {

                    console.log(response.data)
                    /*    txtId.current.value = response.data[0].idrequisicion;
                       txtConcepto.current.value = response.data[0].concepto;
                       txtObservacion.current.value = response.data[0].observaciones;
                       seleccionarDetalle(response.data[0].idrequisicion)
                        */

                } else {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No existe un Tipo de Retención con este codigo', icono: 'informacion' });
                    txtConcepto.current.value = '';
                    txtObservacion.current.value = '';
                }
            }
            setActivate(false);
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    };

    const validarTipoReten = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {

                seleccionarRegistroTipReten(event.target.value);

            } else {
                txtConcepto.current.value = '';
                txtObservacion.current.value = '';
                txtId.current.value = '';
            }
        }
    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="md"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {/* 
                seleccionarRegistros() */
                setOperacion(props.operacion)
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light">{operacion === 1 ? 'Incluir Prodcutos.' : operacion === 2 ? 'Modificar Prodcutos.' : operacion === 3 ? 'Eliminar Prodcutos.' : 'Consultar Prodcutos.'}</div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 row mx-auto px-0">
                    <div class="input-group input-group-sm mb-2 col-md-5">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Codigo:</span>
                        <input type="text" class="form-control text-uppercase" ref={txtId} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarTipoReten} onBlur={validarTipoReten} />
                        <button type="button" class="btn btn-success" onClick={() => setMostrar(true)}><i className="fas fa-search"></i></button>

                    </div>
                    <div className='col-md-7'></div>
                    <div class="input-group input-group-sm mb-2 col-md-12">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Descripción:</span>
                        <textarea type="textarea" style={{ height: 40 }} class="form-control text-uppercase" ref={txtConcepto} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                    </div>
                    <div className='col-md-5'></div>
                    <div class="input-group input-group-sm mb-2 col-md-7">
                        <span class="input-group-text" id="inputGroup-sizing-sm">Cantidad:</span>
                        <input type="text" class="form-control text-uppercase" ref={txtId} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onKeyUp={validarTipoReten} onBlur={validarTipoReten} />
                                     </div>

                </div>

            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={seleccionarClassPresupuestaria}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default AgregarProducto;